<template>
  <app-modal
    name="choose-tax-period-modal"
    :title="$t('vat.form.title.VATReturn')"
    @before-open="beforeOpen"
    :ok-text="$t('app.yes')"
    @on-ok="onOk"
  >
    <div>
      <b-form-group v-slot="{ ariaDescribedby }" class="d-flex flex-row">
        <b-form-radio-group
          id="radio-group-kieu-ky"
          v-model="type"
          @change="onChangeKieuKy"
          :options="optionsKieuKy"
          :aria-describedby="ariaDescribedby"
          name="radio-options-kieu-ky"
        />
      </b-form-group>
      <div class="d-flex flex-row justify-content-center align-items-center gap-8">
        <b-form-group
          :label="this.type === 'Q' ? `${$t('app.quarter')}:` : `${$t('app.month')}:`"
          label-for="nested-month"
          label-cols-sm="6"
          label-align-sm="right"
        >
          <b-form-input
            min="1"
            :max="type === 'Q' ? 4 : 12"
            type="number"
            id="nested-month"
            style="max-width: 80px"
            v-model="month"
          />
        </b-form-group>

        <b-form-group
          :label="$t('app.year') + ':'"
          label-for="nested-year"
          label-cols-sm="4"
          label-align-sm="right"
        >
          <b-form-input
            type="number"
            min="2000"
            :max="thisYear()"
            id="nested-year"
            style="max-width: 100px"
            v-model="year"
          />
        </b-form-group>
      </div>
      <b-form-group v-slot="{ ariaDescribedby }">
        <b-form-radio v-model="isFirstTime" :aria-describedby="ariaDescribedby" name="some-radios" :value="true">{{ $t('vat.form.initialDeclaration') }}</b-form-radio>
        <b-form-radio v-model="isFirstTime" :aria-describedby="ariaDescribedby" name="some-radios" :value="false">{{ $t('vat.form.amendedDeclaration') }}</b-form-radio>
      </b-form-group>
      <div>
        <b-form-group
          v-if="!isFirstTime"
          :label="$t('vat.form.amendmentNo') + ':'"
          label-for="nested-time"
        >
          <b-form-input
            type="number"
            min="1"
            max="100"
            id="nested-time"
            v-model="times"
          />
        </b-form-group>
      </div>

      <b-form-group :label="$t('vat.form.listOfBusinessSectors') + ':'" label-for="input-3">
        <b-form-select
          id="input-3"
          v-model="name"
          :options="optionsNganhNghe"
          required
        ></b-form-select>
      </b-form-group>
    </div>
  </app-modal>
</template>
<script>
import ToastUtils from '@/utils/toast';
import AppModal from '@/components/app-modal';
import SellerProxy from '@/store/proxies/e-invoice/seller-proxy';

export default {
  name: 'ChooseTaxPeriodModal',
  components: { AppModal },
  data() {
    return {
      month: this.thisMonth(),
      year: this.thisYear(),
      type: 'M',
      name: 'Hoạt động sản xuất kinh doanh thông thường',
      isFirstTime: true,
      times: 1,
      formModel: {
        ten_NganhNghe: '',
        kieuKy: 'M',
        kyKKhai: '',
        TKhaiThueSoLan: 0,
        maCQTNoiNop: '',
        tenCQTNoiNop: '',
        company_tax_code: '',
      },
      optionsKieuKy: [
        { text: this.$t('vat.form.kieuKy.options.M'), value: 'M' },
        { text: this.$t('vat.form.kieuKy.options.Q'), value: 'Q' },
      ],
      optionsNganhNghe: [{ text: 'Hoạt động sản xuất kinh doanh thông thường', value: 'Hoạt động sản xuất kinh doanh thông thường' }],
    };
  },
  methods: {
    thisMonth() {
      const date = new Date();
      return date.getMonth() + 1;
    },
    thisYear() {
      const date = new Date();
      return date.getFullYear();
    },
    onOk() {
      this.formModel.kieuKy = this.type;
      this.formModel.ten_NganhNghe = this.name;
      this.formModel.kyKKhai = `${this.month}/${this.year}`;
      this.formModel.TKhaiThueSoLan = this.isFirstTime ? 0 : this.times;

      this.$modal.show('vat-return-modal', { model: this.formModel });
      this.$modal.hide('choose-tax-period-modal', { isOk: true });
    },
    onCancel() {
      this.$modal.hide('choose-tax-period-modal', { isOk: true });
    },
    beforeOpen(event) {
      this.formModel = event.params;
      this.fetchSellerInformation();
    },
    fetchSellerInformation() {
      new SellerProxy()
        .getSellerInformation()
        .then((res) => {
          if (res) {
            const { approval_unit, approval_unit_code, tax_code } = res;
            this.formModel = {
              ...this.formModel,
              tenCQTNoiNop: approval_unit,
              maCQTNoiNop: approval_unit_code,
              company_tax_code: tax_code,
            };
          }
        })
        .catch((error) => {
          ToastUtils.showToast('error', error.message || error);
        });
    },
    onChangeKieuKy(value) {
      if (value === 'M') {
        this.month = this.thisMonth();
      } else if (value === 'Q') {
        this.month = 1;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/value-added-tax/choose-tax-period/choose-tax-period-modal.vue